import { MaatAuditPlanStatus } from '../constants/maat-audit-plan-status.constants';

import { LoggedInUserRoleFlags } from '../interfaces/logged-in-user-role-flags.interface';

export class MaatJobAccess {
  private loggedInUserRoleFlags: LoggedInUserRoleFlags;
  private planStatus: MaatAuditPlanStatus;

  constructor(
    loggedInUserRoleFlags: LoggedInUserRoleFlags,
    planStatus: MaatAuditPlanStatus
  ) {
    this.loggedInUserRoleFlags = loggedInUserRoleFlags;
    this.planStatus = planStatus;
  }

  private loggedInUserRoleIsMaatManager = () =>
      this.loggedInUserRoleFlags?.isMaatManager ?? false;

  private loggedInUserRoleIsMaatProjectOfficer = () =>
      this.loggedInUserRoleFlags?.isMaatProjectOfficer ?? false;

  private loggedInUserRoleIsMaatSeniorProjectOfficer = () =>
    this.loggedInUserRoleFlags?.isMaatSeniorProjectOfficer ?? false;

  private loggedInUserRoleIsMaatHeadContractor = () =>
    this.loggedInUserRoleFlags?.isMaatHeadContractor ?? false;

  canEdit(): boolean {
    const editableMaatProjectOfficerStatuses = [
      MaatAuditPlanStatus.AuditStarted,
      MaatAuditPlanStatus.DocumentsRequested,
      MaatAuditPlanStatus.DocumentsOverdue,
      MaatAuditPlanStatus.DocumentsSupplied,
      MaatAuditPlanStatus.AwaitingInspection,
      MaatAuditPlanStatus.NcqInProgress
    ];

    const editableMaatSeniorProjectOfficerStatuses = [
      MaatAuditPlanStatus.AuditStarted,
      MaatAuditPlanStatus.DocumentsRequested,
      MaatAuditPlanStatus.DocumentsOverdue,
      MaatAuditPlanStatus.DocumentsSupplied,
      MaatAuditPlanStatus.AwaitingInspection,
      MaatAuditPlanStatus.NcqInProgress,
      MaatAuditPlanStatus.ReferredToSeniorProjectOfficer
    ];

    const editableMaatManagerStatuses = [
      MaatAuditPlanStatus.ReferredToManager,
      MaatAuditPlanStatus.Completed
    ];

    const editableMaatHeadContractorStatuses = [
      MaatAuditPlanStatus.DocumentsRequested,
      MaatAuditPlanStatus.DocumentsOverdue
    ];

    const canEditForMaatProjectOfficer = () =>
      editableMaatProjectOfficerStatuses.includes(this.planStatus) &&
      this.loggedInUserRoleIsMaatProjectOfficer();

    const canEditForMaatSeniorProjectOfficer = () =>
      editableMaatSeniorProjectOfficerStatuses.includes(this.planStatus) &&
      this.loggedInUserRoleIsMaatSeniorProjectOfficer();

    const canEditForMaatManager = () =>
      editableMaatManagerStatuses.includes(this.planStatus) &&
      this.loggedInUserRoleIsMaatManager();

    const canEditForMaatHeadContractor = () =>
      editableMaatHeadContractorStatuses.includes(this.planStatus) &&
      this.loggedInUserRoleIsMaatHeadContractor();

    const canEdit = canEditForMaatProjectOfficer() ||
      canEditForMaatSeniorProjectOfficer() ||
      canEditForMaatManager() ||
      canEditForMaatHeadContractor();

    return canEdit;
  }

  canSeePropertyHistory(): boolean {
    const hasValidRole = this.loggedInUserRoleIsMaatProjectOfficer() ||
                         this.loggedInUserRoleIsMaatSeniorProjectOfficer() ||
                         this.loggedInUserRoleIsMaatManager();

    return hasValidRole;
  }
}
